// @ts-ignore
Map.prototype.toObject = function (convert = (o) => o, filter = () => true) {
  return Array.from(this.entries()).reduce((p, [key, value]) => {
    const newValue = convert(value);
    if (filter(newValue)) {
      p[key] = newValue;
    }
    return p;
  }, {});
};

// @ts-ignore
Map.prototype.toArray = function (convert = (o) => o) {
  return Array.from(this.values(), convert);
};
